import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCart = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#pet__clip0_1958_3779)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "white",
			d: "M14.67 9.25886L15.9831 3.48108C16.0779 3.06391 15.7609 2.66666 15.3331 2.66666H4.42244L4.16783 1.42194C4.10439 1.11169 3.83139 0.888885 3.51469 0.888885H0.666667C0.298472 0.888885 0 1.18736 0 1.55555V2C0 2.36819 0.298472 2.66666 0.666667 2.66666H2.60786L4.55919 12.2065C4.09236 12.475 3.77778 12.9784 3.77778 13.5556C3.77778 14.4147 4.47422 15.1111 5.33333 15.1111C6.19244 15.1111 6.88889 14.4147 6.88889 13.5556C6.88889 13.1202 6.70981 12.7268 6.42156 12.4444H12.2451C11.9569 12.7268 11.7778 13.1202 11.7778 13.5556C11.7778 14.4147 12.4742 15.1111 13.3333 15.1111C14.1924 15.1111 14.8889 14.4147 14.8889 13.5556C14.8889 12.9397 14.5309 12.4074 14.0117 12.1554L14.1649 11.4811C14.2597 11.0639 13.9427 10.6667 13.5149 10.6667H6.05881L5.877 9.77777H14.0199C14.3312 9.77777 14.601 9.56238 14.67 9.25886Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_1958_3779",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgCart);
export default ForwardRef;
